/**
 * components/tableElements/TableBody.jsx
 */

import {
    useCrudListState,
    useCrudListDispatch,
    ACTIONS,
    getEditUrl,
} from "../../context/CrudContext";
import StatusBadge from "./StatusBadge";
import ActionDropdown from "./ActionDropdown";

const formatDate = (str) => {
    if (!str) return "—";
    const d = new Date(str.replace(" ", "T"));
    return isNaN(d)
        ? str
        : d.toLocaleDateString(undefined, {
              year: "numeric",
              month: "short",
              day: "numeric",
          });
};

export default function TableBody({
    onToggleStatus,
    onDuplicate,
    onTrash,
    onRestore,
    onPermanentDelete,
}) {
    const state = useCrudListState();
    const dispatch = useCrudListDispatch();

    return (
        <tbody className="divide-y divide-gray-200 bg-white">
            {state.items.map((form) => {
                const isSelected = state.selected.includes(form.id);
                return (
                    <tr
                        key={form.id}
                        className={`hover:bg-gray-50 transition-colors ${
                            isSelected ? "bg-accent-subtle" : ""
                        }`}
                    >
                        {/* Checkbox */}
                        <td className="px-4 sm:px-6 py-4">
                            <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() =>
                                    dispatch({
                                        type: ACTIONS.TOGGLE_SELECT,
                                        payload: form.id,
                                    })
                                }
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                            />
                        </td>

                        {/* ID */}
                        <td className="px-3 py-4 whitespace-nowrap">
                            <span className="text-sm text-gray-500 font-mono">
                                #{form.id}
                            </span>
                        </td>

                        {/* Title */}
                        <td className="px-3 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">
                                <a
                                    href={getEditUrl(form.id)}
                                    className="text-sm font-medium text-gray-900 hover:text-blue-600 no-underline transition-colors"
                                >
                                    {form.title}
                                </a>
                            </div>
                        </td>

                        {/* Status */}
                        <td className="px-3 py-4 whitespace-nowrap">
                            <StatusBadge status={form.status} />
                        </td>

                        {/* Applies To */}
                        <td className="px-3 py-4 whitespace-nowrap">
                            {form.apply_to === "selected" ? (
                                <span className="inline-flex items-center rounded-full border border-blue-100 bg-blue-50 px-2.5 py-0.5 text-[11px] font-medium text-blue-600">
                                    Selected Only
                                </span>
                            ) : (
                                <span className="inline-flex items-center rounded-full border border-gray-100 bg-gray-50 px-2.5 py-0.5 text-[11px] font-medium text-gray-500">
                                    All Products
                                </span>
                            )}
                        </td>

                        {/* Date */}
                        <td className="px-3 py-4 whitespace-nowrap">
                            <span className="text-sm text-gray-500">
                                {formatDate(form.created_at)}
                            </span>
                        </td>

                        {/* Actions */}
                        <td className="px-3 py-4 whitespace-nowrap text-end">
                            <ActionDropdown
                                form={form}
                                onToggleStatus={onToggleStatus}
                                onDuplicate={onDuplicate}
                                onTrash={onTrash}
                                onRestore={onRestore}
                                onPermanentDelete={onPermanentDelete}
                            />
                        </td>
                    </tr>
                );
            })}
        </tbody>
    );
}
